import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s64, Spacings.s0],

      [BreakPointsMedia.LG]: {
        padding: [Spacings.s40, Spacings.s0],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    content: {
      display: 'grid',
      gridGap: Spacings.s24,
      gridTemplateColumns: 'repeat(3,4fr)',
      marginBottom: Spacings.s40,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        gridTemplateColumns: '12fr',
        gridTemplateRows: '12fr',
        gridGap: Spacings.s12,
      },
    },
    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      maxWidth: 456,
      margin: [Spacings.s0, 'auto', Spacings.s48],
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l36,
      color: TextColors.tint1,
      overflow: 'hidden',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        lineClamp: 4,
        margin: [Spacings.s0, 'auto', Spacings.s32],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        lineClamp: 5,
        margin: [Spacings.s0, 'auto', Spacings.s24],
        fontSize: Spacings.s24,
        lineHeight: LineHeights.l32,
      },
    },
    actionItemHolder: {
      display: 'flex',
      margin: [Spacings.s0, 'auto'],
      justifyContent: 'center',
    },
    action: {
      padding: [Spacings.s16, Spacings.s32],
      fontWeight: FontWeights.medium,
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: '100%',
      },
    },
    // Skeleton
    skeletonTitle: {
      extend: 'title',
      height: 40,
    },
    skeletonContent: {
      extend: 'content',
      height: 250,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        height: 650,
        gridTemplateRows: 'repeat( 3, minmax(160px, 1fr) )',
      },
    },
    skeletonBtn: {
      extend: 'actionItemHolder',
      height: 56,
      width: 230,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: '100%',
      },
    },
  }),
  {
    name: 'how-to-icons',
  },
);

export default useStyles;
